import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAccessToken, fetchData, putData } from '../common/MSALHelper';
import { useMsal } from "@azure/msal-react";
import ContributionList from "./ContributionList";
import ReceiptList from "./ReceiptList";
import "./form.css"

export default function CommunityMember() {
    const { instance, accounts } = useMsal();
    const { member_id } = useParams();
    const [formValid, setFormValid] = useState(true);
    const [formData, setFormData] = useState({
        CallName: null,
        SaintName: null,
        LastName: null,
        MiddleName: null,
        FirstName: null,
        HNDOG_SpouseName: null,
        ChiHoi: null,
        Address: null,
        City: null,
        State: null,
        PostalCode: null,
        Country: null,
        HomePhone: null,
        WorkPhone: null,
        MobilePhone: null,
        Fax: null,
        Email: null,
        Note: null,
        Receipt: false,
        ReceiptName: null,
        ReceiptAddress: null,
        ReceiptCity: null,
        ReceiptState: null,
        ReceiptPostalCode: null,
        ReceiptCountry: null,
        ReceiptPhone: null,
        ReceiptMark: false,
        HNDOG_PLTT_Mark: false,
        HNDOG_PLTT_Date: null,
        HNDOG_PLTT_Note: null,
        HNDOG_Flag: false,
        HNDOG_PLTT: null,
        Archive: false,
        AddressInvalid: false,
        QuaDoi: false,
        NgayQuaDoi: null,
        NgayQuaDoiSecondary: null,
        TenQuaDoi: null,
        TenQuaDoiSecondary: null,
        RegistrationDate: null
    });
    const fields = Object.keys(formData);

    const chunkFields = (fields, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < fields.length; i += chunkSize) {
        chunks.push(fields.slice(i, i + chunkSize));
        }
        return chunks;
    };
    const getInputType = (field) => {
        const value = formData[field];
        
        if (typeof value === 'boolean') {
            return 'checkbox';
        } else if (field.includes('Date') || field.includes('NgayQuaDoi'))
        {
            return 'date';
        }
    };
    const inputStyle = (field) => ({
        padding: '10px',
        margin: '10px 0',
        borderRadius: '4px',
        outline: 'none',
        width: '100%',
    });

    const fieldChunks = chunkFields(fields, 5);
    const [refreshReceiptListBool, setRefreshReceiptListBool] = useState(false);

    useEffect(() => {
        const fetchParishioner = async () => {
            try {
                getAccessToken(instance, accounts).then(response => {
                    let accessToken = response;
                    fetchData(accessToken, `/users/${member_id}`, fetch_response => {
                        if (fetch_response.ok)
                            return fetch_response.json();
                        else {
                            console.error('Failed to fetch parishioner data');
                        }
                    }, data => {
                        console.log(data);
                        const parishionerData = data;
                        setFormData({
                            ...parishionerData,
                            // Convert dates to a format suitable for date input
                            HNDOG_PLTT_Date: parishionerData.HNDOG_PLTT_Date ? new Date(parishionerData.HNDOG_PLTT_Date).toISOString().split('T')[0] : null,
                            NgayQuaDoi: parishionerData.NgayQuaDoi ? new Date(parishionerData.NgayQuaDoi).toISOString().split('T')[0] : null,
                            NgayQuaDoiSpouse: parishionerData.NgayQuaDoiSpouse ? new Date(parishionerData.NgayQuaDoiSpouse).toISOString().split('T')[0] : null,
                            RegistrationDate: parishionerData.RegistrationDate ? new Date(parishionerData.RegistrationDate).toISOString().split('T')[0] : null
                        });
                    });
                    // fetchData(accessToken, `/contribution/${member_id}`, fetch_response => {
                    //     if (fetch_response.ok)
                    //         return fetch_response.json();
                    //     else
                    //         console.error('Failed to fetch contribution data');
                    // }, data => {
                    //     console.log(data);
                    // });
                    // fetchData(accessToken, `/receipt/${member_id}`, fetch_response => {
                    //     if (fetch_response.ok)
                    //         return fetch_response.json();
                    //     else
                    //         console.error(`Failed to fetch receipt data`);
                    // }, data => {
                    //     console.log(data);
                    // })
                });
            } catch (error) {
                console.error('Error fetching parishioner data:', error);
            }
        };

        fetchParishioner();
    }, [member_id, accounts, instance]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            getAccessToken(instance, accounts).then(accessToken => {
                putData(accessToken, `/member/${member_id}`, f_response => {
                    if (f_response.ok) {
                        console.log('Parishioner updated successfully');
                    }
                    else console.error('Failed to update parishioner');
                }, data => {
                    
                }, JSON.stringify(formData))
            })
        } catch (error) {
            console.error('Error updating parishioner:', error);
        }
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData({ ...formData, [name]: newValue });
    };

    const refresh_receipt_list = () => {
        setRefreshReceiptListBool(!refreshReceiptListBool);
    }

    return <div className="form-box">
    <h2>Update Community Member</h2>
    <form id="updateForm" onSubmit={handleSubmit}>
        {/* Render input fields for each parishioner attribute */}
        {/* {Object.entries(formData).map(([key, value]) => (
            <div key={key}>
                <label htmlFor={key}>{key}: </label><br />
                {
                    // For boolean fields, render checkboxes
                }
                {typeof value === 'boolean' ?
                    <input type="checkbox" id={key} name={key} checked={value} onChange={handleChange} />
                    :
                    <input type={key.includes('Date') || key.includes('NgayQuaDoi') ? 'date' : 'text'} id={key} name={key} value={value === null ? null : value} onChange={handleChange} readOnly={key === "ID"} />
                }
                <br />
            </div>
        ))} */}
        {fieldChunks.map((chunk, chunkIndex) => (
                <div key={chunkIndex} style={{ display: 'flex', justifyContent: 'space-evenly', marginBottom: '20px', width: '100%', }}>
                    {chunk.map((field) => (
                        <div key={field} style={{ flex: 1, marginRight: chunk.length > 1 ? '10px' : '0', }}>
                            <label>
                                {field.charAt(0).toUpperCase() + field.slice(1)}:
                                {typeof formData[field] === 'boolean' ?
                                <input id={field}
                                    type='checkbox' // Dynamically set input type
                                    name={field}
                                    checked={formData[field]}
                                    onChange={handleChange}
                                    style={inputStyle(field)}
                                />
                                :
                                <input id={field}
                                    type={getInputType(field)} // Dynamically set input type
                                    name={field}
                                    value={formData[field] === null ? null : formData[field]}
                                    onChange={handleChange}
                                    style={inputStyle(field)}
                                />
                                }
                            </label>
                        </div>
                    ))}
                    {chunkIndex < fieldChunks.length - 1 && <hr />} {/* <hr /> is a horizontal line for separation */}
                </div>
            ))}
        <button type="submit" disabled={!formValid}>Update</button>
        {!formValid && <p style={{ color: 'red' }}>Please fill out the required fields!</p>}
    </form>
    <div>
        Contributions
        <ContributionList member_id={member_id} refresh_receipt_list={refresh_receipt_list} />
    </div>
    <div>
        Receipts
        <ReceiptList member_id={member_id} refresh_toggle={refreshReceiptListBool} />
    </div>
</div>
}